type ImportMetaWithGlob = ImportMeta & {
	glob: <T>(
		pattern: string,
		options: { eager: true },
	) => Record<string, T>;
};

const blogModules = (import.meta as ImportMetaWithGlob).glob<{
	default: unknown;
}>("./post.*.yaml", { eager: true });

export const blogFiles = Object.values(blogModules).map(
	(module) => module.default,
);
